/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

'use client';

import { useState } from 'react';
import {
  Collapse, CardBody, Card, CardHeader,
} from 'reactstrap';

function AccordianCommon({ elements }) {
  const [items, setItems] = useState(elements.map((_elem, key) => (key === 0)));

  const switchState = (id) => {
    setItems((prev) => prev.map((item, key) => {
      if (key === id) {
        return !item;
      }
      return false;
    }));
  };

  return (
    <>
      {items.map((state, key) => (
        <Card className="border-0 rounded mb-2 shadow" key={elements[key].id}>
          <div
            onClick={() => switchState(key)}
            className={
              state
                ? 'faq position-relative text-primary'
                : 'faq position-relative text-dark'
            }
          >
            <CardHeader className="border-0 bg-light p-3">
              <h6 className="title mb-0">
                {' '}
                {elements[key].question}
                <i
                  className={
                    state
                      ? 'mdi mdi-chevron-up float-end'
                      : 'mdi mdi-chevron-down float-end'
                  }
                />
              </h6>
            </CardHeader>
          </div>
          <Collapse isOpen={state}>
            <CardBody>
              <p className="text-muted mb-0 faq-ans">{elements[key].answer}</p>
            </CardBody>
          </Collapse>
        </Card>
      ))}
    </>
  );
}

export default AccordianCommon;
